import {useEffect} from "react";
import {COOKIE_PREFERENCES_LINK_ENABLED} from "Setup/config";

const WRAPPER_ID = "cmpwrapper";
const STYLE_ID = "morpheus-hide-cmp-recall";
const RECALL_CSS = ".cmpboxrecall {display: none !important;}";

// The consent manager renders itself into a shadow root on #cmpwrapper, which page level CSS cannot
// reach into. A stylesheet placed inside the shadow root can, and unlike hiding the node itself it
// still holds after the manager re-renders the icon (it puts it back when the panel is closed).
const hideRecallIcon = () => {
    const shadowRoot = document.getElementById(WRAPPER_ID)?.shadowRoot;

    if (!shadowRoot) return false;
    if (shadowRoot.querySelector(`#${STYLE_ID}`)) return true;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = RECALL_CSS;
    shadowRoot.appendChild(style);

    return true;
};

const useHideConsentRecallIcon = () => {
    useEffect(() => {
        if (!COOKIE_PREFERENCES_LINK_ENABLED || hideRecallIcon()) return;

        // The manager loads on its own schedule and appends its wrapper straight to the body, so
        // wait for it rather than racing it. There is nothing to watch for once it has landed.
        const observer = new MutationObserver(() => {
            if (hideRecallIcon()) observer.disconnect();
        });

        observer.observe(document.body, {childList: true});

        return () => observer.disconnect();
    }, []);
};

export default useHideConsentRecallIcon;
